import React, { Component } from 'react'
import Switch from '@material-ui/core/Switch';


export default class DesktopAlarm extends Component {
  render() {
    const { openAlarm, alarms, alarm, closeAlarm } = this.props;
    return (
      <div className="repeat d-flex flex-column">
        <div className="repeat__header d-flex">
          <h2>هشدار</h2>
          <Switch
            // checked={this.props.switchs.value}
            color="primary"
            inputProps={{ 'aria-label': 'primary checkbox' }}
            onChange={(e) => openAlarm()}
          />
        </div>
        <div className="repeat__buttons ui buttons d-flex flex-wrap">
          {
            alarms.map(item => (
              <div className={alarm ? "ui button" : "ui button disabled"} style={item.checked && alarm ? { border: '1px solid #506ED1', color: '#506ED1' } : { color: '#d1d1d1', border: '1px solid #d1d1d1' }} onClick={() => closeAlarm(item.name, item.id)}>{item.name}</div>
            ))
          }
        </div>
      </div>
    );
  }
}